import { r2Fetch } from './client';
import { R2FileSaveResponse } from '../types';

export interface R2FileSaveParams {
  bucket_id: string;
  key: string;
  content?: string | null;
  metadata?: Record<string, string>;
  if_match?: string;
}

export async function r2FileSave(
  params: R2FileSaveParams
): Promise<R2FileSaveResponse> {
  return r2Fetch<R2FileSaveResponse>('/rpc/r2_file_save', {
    body: params,
  });
}
